import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TagCatalogApi, TagCatalogComponent } from "src/app/components/tag-catalog/tag-catalog.component";
import { ActivitySection } from "src/app/constants/activity-log";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ConfigService } from "src/app/services/config.service";

/**
 * Admin ▸ Tags ▸ Kontakte - same catalog UI as the Aufgaben tab. Contact tags store the visible
 * name in `title`; the legacy `tag` field is passed through unchanged on rename.
 */
@Component({
  selector: "app-config-tags.page",
  imports: [TagCatalogComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<app-tag-catalog [api]="api" [heading]="heading" [description]="description"></app-tag-catalog>`,
})
export class ConfigTagsPageComponent implements OnInit {
  readonly heading = $localize`:@@contactTagsTitle:Contact Tags`;
  readonly description = $localize`:@@contactTagsDescription:Define tags to categorise contacts.`;

  private contactTags: { id: number; tag: string | null; title: string; systemKey?: string | null }[] = [];

  readonly api: TagCatalogApi = {
    load: async () => {
      // getContactTags also refreshes ConfigService.contactTags$, which the contact pages read.
      const result = await this.configService.getContactTags({});
      this.contactTags = result.contactTags ?? [];
      // Standard tags (e.g. "Steuerberater", set by Gesellschaften) can't be renamed or deleted.
      return { ...result, tags: this.contactTags.map((t) => ({ id: t.id, name: t.title, locked: !!t.systemKey })) };
    },
    save: (id, name) => {
      const existing = this.contactTags.find((t) => t.id === id);
      return this.configService.writeContactTags({
        contactTags: [{ id: id ?? 0, tag: existing?.tag ?? null, title: name }],
      });
    },
    remove: (tag) => this.configService.deleteContactTag({ contactTags: [{ id: tag.id }] }),
  };

  constructor(private configService: ConfigService, private activityLog: ActivityLogService) {}

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_TAGS });
  }
}
